module.exports = __webpack_public_path__ + "static/erp-laptop-screen1-47f2473dd5420d41438b276deb9719c0.jpeg";